import { FetchResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface SetExtraDataOnCartMutationObject {
  mutation: {
    setExtraDataOnCart: {
      __args: {
        input: {
          cart_id: string
          data: Record<string, string>
        }
      }
      cart: {
        id: boolean
      }
    }
  }
}

export const setExtraDataOnCartMutationObject: SetExtraDataOnCartMutationObject = {
  mutation: {
    setExtraDataOnCart: {
      __args: {
        input: {
          cart_id: '',
          data: {}
        }
      },
      cart: {
        id: true
      }
    }
  }
}

interface SetExtraDataOnCartMutationInput {
  cartId: string
  data: Record<string, string>
}

export interface SetExtraDataOnCartMutationResponseType {
  cart: {
    id: string
  }
}

export type SetExtraDataOnCartMutation = (input: SetExtraDataOnCartMutationInput) => Promise<FetchResult<SetExtraDataOnCartMutationResponseType>>

export const createSetExtraDataOnCartMutation = ({ getMutations }: ServiceDependencies): SetExtraDataOnCartMutation => async ({ cartId, data }) => {
  const mutation = getMutations().setExtraDataCartMutation
  mutation.mutation.setExtraDataOnCart.__args.input.cart_id = cartId
  mutation.mutation.setExtraDataOnCart.__args.input.data = data

  return apolloClient.mutate({
    mutation: gql`${jsonToGraphQLQuery(mutation)}`,
    fetchPolicy: 'no-cache'
  })
}
